import { Stack, Typography, useTheme } from '@mui/material';

export const CohortCharacteristicsTabularRow = ({
  name,
  value,
  index,
}: {
  name: string;
  value: string;
  index: number;
}) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      sx={{
        backgroundColor:
          index % 2 === 0 ? theme.palette.cardBackground.main : theme.palette.background.default,
        px: 4,
        py: 2,
      }}
    >
      <Typography variant="body2" color={theme.palette.text.primary}>
        {name}
      </Typography>
      <Typography variant="body2" color={theme.palette.text.primary}>
        {value}
      </Typography>
    </Stack>
  );
};

export default CohortCharacteristicsTabularRow;
